<template src="./infinite-scroll.html"></template>
<style lang="less" src="./infinite-scroll.less"></style>

<script>    
    import InfiniteLoading from 'vue-infinite-loading'
    import Loading from '@/components/loadings/loading/loading'

    export default {
        components: {
           'infinite-loading': InfiniteLoading,
           Loading
        },    
        methods: {
            reset() {
                this.$refs.infiniteLoading.stateChanger.reset();
            },
            infiniteHandler($state) {
                this.$emit("infinite", $state);
            }
        }
	} 
</script>
